import type {
  PropertyPaneConfig,
  PropertyPaneControlConfig,
} from "legacy/constants/PropertyControlConstants";

export function isPropertyPaneControlConfig<T>(
  value: PropertyPaneConfig<T>,
): value is PropertyPaneControlConfig<T> {
  return "propertyName" in value;
}
